import { CircularProgress, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ReactPlayer from 'react-player';
import { FaceResultEms } from './FaceResultEms';

export function FaceTest({ video, testDetails }) {
  return (
    <>
      <Stack spacing={3}>
        {video ? (
          video.length === 0 ? ( //the video is being loaded
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress color="inherit" />
              <Typography>Video is downloading</Typography>
            </Box>
          ) : (
            <Box>
              <ReactPlayer style={{ margin: 'auto' }} height="280px" width="480px" controls={true} url={video} />
            </Box>
          )
        ) : null}

        {testDetails?.model1ResultOrEmpty && <FaceResultEms model1Result={testDetails.model1ResultOrEmpty} />}
      </Stack>
    </>
  );
}
